var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTransfer = function SvgTransfer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.31182 3.80045L5.07026 1.99029C5.33963 1.71299 5.33321 1.26982 5.05591 1.00045C4.77861 0.731068 4.33544 0.737491 4.06606 1.01479L0 5.20045H11.3559C11.7425 5.20045 12.0559 4.88704 12.0559 4.50045C12.0559 4.11385 11.7425 3.80045 11.3559 3.80045H3.31182Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.73386 9.20026L7.02684 11.0107C6.76163 11.292 6.77466 11.735 7.05594 12.0003C7.33723 12.2655 7.78025 12.2524 8.04547 11.9712L11.978 7.80026L0.755943 7.80026C0.369344 7.80026 0.0559439 8.11366 0.0559438 8.50026C0.0559438 8.88686 0.369344 9.20026 0.755944 9.20026L8.73386 9.20026Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransfer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transfer.0913254d.svg";
export { ForwardRef as ReactComponent };